__turbopack_context__.v({
  "root": "FlexSpacer-module__lv_ZwW__root",
});
